import {
  postSeedingProposalAccept as postSeedingProposalAcceptApi,
  postSeedingProposalReject as postSeedingProposalRejectApi,
} from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import {
  type SeedingProposalAcceptResponse,
  SeedingProposalAcceptResponseSchema,
  type SeedingProposalRejectResponse,
  SeedingProposalRejectResponseSchema,
} from './seeding-proposal-action.dto';

export interface SeedingProposalAcceptRequest {
  participationId: number;
}

export interface SeedingProposalRejectRequest {
  participationId: number;
  rejectionReasonCodes: string[];
}

export const postSeedingProposalAcceptService = withServiceErrorCapture(
  lazyPipe(
    async ({
      participationId,
    }: SeedingProposalAcceptRequest): Promise<SeedingProposalAcceptResponse> => {
      const apiResponse = await postSeedingProposalAcceptApi(participationId);
      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '제안 수락에 실패했습니다.');
      }
      return apiResponse.data;
    },
    validateServiceResponse(SeedingProposalAcceptResponseSchema),
  ),
);

export const postSeedingProposalRejectService = withServiceErrorCapture(
  lazyPipe(
    // 204 No Content — 응답 본문이 없어 meta/data 를 읽지 않는다(빈 본문이라 표준 래퍼가 아님).
    // BE 가 실패면 non-2xx → withApiErrorCapture 가 throw → onError. (SID-4053)
    async ({
      participationId,
      rejectionReasonCodes,
    }: SeedingProposalRejectRequest): Promise<SeedingProposalRejectResponse> => {
      await postSeedingProposalRejectApi({ participationId, rejectionReasonCodes });
    },
    validateServiceResponse(SeedingProposalRejectResponseSchema),
  ),
);
